<template>
    <el-dialog :visible="openDialog"
               width="80%"
               @close="$emit('update:openDialog', false)">

        <h2>1. Upload a CSV</h2>

        <div style="text-align:center;margin-top:50px;">
            <btn cssClass="btn-primary btn-lg" icon="fas fa-cloud-upload-alt" :click="addFile">Upload</btn>
            <input type="file" ref="files" v-on:change="handleFileUpload()" style="visibility:hidden"/>
        </div>

        <template v-if="step >= 2">
            <h2 style="margin-top:30px">2. Map CSV fields</h2>
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th v-for="header in fileData.header">{{ header }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td v-for="header in fileData.header">
                            <select class="form-control" style="min-width:200px;" v-model="mapping[header]">
                                <option :value="null">---</option>
                                <option v-for="o in options" :value="o.id">{{ o.name }}</option>
                            </select>
                        </td>
                    </tr>
                    <tr v-for="line in fileData.lines">
                        <td v-for="entry in line">{{ entry }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h2 style="margin-top:30px">3. Area</h2>
            <div style="display: flex; align-items: center">
                Include zip codes in a <input type="number" class="form-control" style="width:60px;margin:0 15px;"
                                              v-model="defaultRadius"/> miles radius
            </div>
            <div style="font-style:italic">(ignored if miles specified in the CSV)</div>

            <el-alert v-if="errorMessage !== null" title="Error: " type="error" :closable="false"
                      style="margin-top:30px">
                {{ errorMessage }}
            </el-alert>

            <div style="text-align:center;margin-top:30px;">
                <btn cssClass="btn-primary btn-lg" icon="fas fa-cogs" :click="processFile">Process</btn>
            </div>

        </template>

    </el-dialog>
</template>

<script>
export default {
    props: {
        openDialog: { type: Boolean, required: true },
        areaId: { type: Number, required: true },
    },
    data() {
        let options = [
            { id: 'city', 'name': 'City' },
            { id: 'state', 'name': 'State' },
            { id: 'city-state', 'name': 'City, State' },
            { id: 'zip', 'name': 'Zip Code' },
            { id: 'radius', 'name': 'Radius' },
        ];

        return {
            files: '',
            step: 1,
            promiseResolve: null,
            fileData: { header: [], lines: [[]] },
            mapping: {},
            options: options,
            defaultRadius: 50,
            errorMessage: null,
        };
    },
    computed: {
        isRadiusSelected: function () {
            let values = _.valuesIn(this.mapping);
            return values.includes('radius');
        },
    },
    methods: {
        addFile() {
            this.$refs.files.click();
            return new Promise((resolve, reject) => {
                this.promiseResolve = resolve;
            });
        },
        handleFileUpload() {
            this.files = this.$refs.files.files;
            this.submitFile();
        },
        submitFile() {
            let formData = new FormData();
            formData.append('files[0]', this.files[0]);

            return axios.post(url('ajax/admin/upload-file'), formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            }).then(response => {
                return axios.post(url('admin/map-upload/upload-csv'), response.data)
                            .then(response => {
                                this.fileData = response.data;
                                this.mapping = response.data.suggestions;
                                if (Array.isArray(this.mapping) && this.mapping.length === 0) {
                                    this.mapping = {};
                                }

                                this.step = 2;
                                this.promiseResolve();
                            });
            });
        },
        processFile() {
            return axios.post(url('admin/map-upload/process'), {
                mapping: this.mapping,
                file_id: this.fileData.file_id,
                default_radius: this.defaultRadius,
            }).then(response => {
                let formData = {};
                formData['data'] = response.data.data;
                formData['area_id'] = this.areaId;
                formData['is_exclusion'] = false;

                if (response.data['processing-strategy'] === 'cities') {
                    formData['radius'] = response.data.radius;
                    return this.addMultipleCities(formData);
                } else {
                    return this.addZipCodes(formData);
                }
            });
        },
        addMultipleCities(formData) {
            return axios.post(this.url('admin/area/add-multiple-cities'), formData).then(response => {
                this.$emit('process');
                this.$emit('update:openDialog', false);
            });
        },
        addZipCodes(formData) {
            return axios.post(this.url('admin/area/add-zip-code'), formData).then(response => {
                this.$emit('process');
                this.$emit('update:openDialog', false);
            });
        },
    },
};
</script>

